import { FaDiscord, FaExternalLinkAlt } from "react-icons/fa";

export default function DiscordContact() {
return <a href="https://discord.com/servers/jaseowns-442558623298617354" className='md:mt-8 animate-slide-top duration-500 inline ml-2 underline hover:no-underline'>
    <div className="my-4 text-center border border-spacing-4 p-4 border-mute border-r-8 border-b-8 border-s-white border-t-white hover:border-t-muted-foreground hover:border-s-muted-foreground hover:bg-muted-foreground">
        <div className='text-2xl inline-block'>
            <b className="p-2">Got a question?</b>
            <FaDiscord className='inline text-4xl' style={{color: "#5865F2"}} /> Discord <FaExternalLinkAlt className='inline' />
            <p className="text-sm">
                Join the Jaseowns community discord and get answers to your questions
            </p>
        </div>
    </div>
</a>
}